import locale from '~/locales/json/en.json'
window.translations ??= {}
window.translations.en = locale.en;